module.exports = __webpack_public_path__ + "assets/images/window.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/window.png
// module id = 262
// module chunks = 1